/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Groups } from './Groups';
import {
    GroupsFromJSON,
    GroupsFromJSONTyped,
    GroupsToJSON,
    GroupsToJSONTyped,
} from './Groups';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseTypecode
 */
export interface ResponseTypecode {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseTypecode
     */
    result: ResponseResult;
    /**
     * 
     * @type {Array<Groups>}
     * @memberof ResponseTypecode
     */
    data: Array<Groups>;
}

/**
 * Check if a given object implements the ResponseTypecode interface.
 */
export function instanceOfResponseTypecode(value: object): value is ResponseTypecode {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseTypecodeFromJSON(json: any): ResponseTypecode {
    return ResponseTypecodeFromJSONTyped(json, false);
}

export function ResponseTypecodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseTypecode {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': ((json['data'] as Array<any>).map(GroupsFromJSON)),
    };
}

export function ResponseTypecodeToJSON(json: any): ResponseTypecode {
    return ResponseTypecodeToJSONTyped(json, false);
}

export function ResponseTypecodeToJSONTyped(value?: ResponseTypecode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': ((value['data'] as Array<any>).map(GroupsToJSON)),
    };
}

